import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const user = window.Telegram?.WebApp?.initDataUnsafe?.user;

  return (
    <div className="p-4 max-w-md mx-auto">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold mb-2">🌐 OMNI-GRID P2P</h1>
        <p className="text-telegram-hint text-sm">
          Giao dịch P2P an toàn, riêng tư
        </p>
        {user && (
          <p className="text-sm mt-2">
            Xin chào, <span className="font-semibold">{user.first_name}</span>!
          </p>
        )}
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <button 
          className="bg-green-500 text-white rounded-xl p-4 text-center"
          onClick={() => navigate('/create-order?type=buy')}
        >
          <div className="text-2xl mb-1">💰</div>
          <div className="font-semibold">Mua Crypto</div>
          <div className="text-xs opacity-80">Mua từ người bán</div>
        </button>
        
        <button 
          className="bg-blue-500 text-white rounded-xl p-4 text-center"
          onClick={() => navigate('/create-order?type=sell')}
        >
          <div className="text-2xl mb-1">💵</div>
          <div className="font-semibold">Bán Crypto</div>
          <div className="text-xs opacity-80">Bán cho người mua</div>
        </button>
      </div>

      {/* Features */}
      <div className="bg-telegram-secondary rounded-xl p-4 mb-6">
        <h2 className="font-semibold mb-3">✨ Tính năng</h2>
        <ul className="space-y-2 text-sm">
          <li className="flex items-center gap-2">
            <span>🔒</span>
            <span>End-to-end encrypted chat</span>
          </li>
          <li className="flex items-center gap-2">
            <span>🛡️</span>
            <span>Escrow tự động bảo vệ</span>
          </li>
          <li className="flex items-center gap-2">
            <span>⚡</span>
            <span>Khớp lệnh AI nhanh chóng</span>
          </li>
          <li className="flex items-center gap-2">
            <span>🔐</span>
            <span>ZK Privacy - không lộ thông tin</span>
          </li>
        </ul>
      </div>

      {/* Stats (placeholder) */}
      <div className="grid grid-cols-3 gap-2 text-center">
        <div className="bg-telegram-secondary rounded-lg p-3">
          <div className="text-lg font-bold">1,234</div>
          <div className="text-xs text-telegram-hint">Giao dịch</div>
        </div>
        <div className="bg-telegram-secondary rounded-lg p-3">
          <div className="text-lg font-bold">$50K</div>
          <div className="text-xs text-telegram-hint">Volume 24h</div>
        </div>
        <div className="bg-telegram-secondary rounded-lg p-3">
          <div className="text-lg font-bold">567</div>
          <div className="text-xs text-telegram-hint">Traders</div>
        </div>
      </div>
    </div>
  );
}
